import React from "react";
import "../../Assets/Styles/pages/homeRedesign.scss";

interface FeatureCardProps {
  /** Selects the `--green`/`--blue` CSS modifiers for icon background, title, and arrow. */
  color: "green" | "blue";
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  /** Lets a sidebar nav item trigger this card's click (see the "Batch Watermark" nav item). */
  triggerRef?: React.Ref<HTMLDivElement>;
}

/** Shared shell for the "Batch Watermark" / "Create Template" home-screen cards. */
const FeatureCard: React.FC<FeatureCardProps> = ({
  color,
  icon,
  title,
  description,
  onClick,
  triggerRef,
}) => (
  <div ref={triggerRef} onClick={onClick} className="home-feature-card">
    <div className={`home-feature-card__icon home-feature-card__icon--${color}`}>
      {icon}
    </div>
    <div className="home-feature-card__body">
      <div className={`home-feature-card__title home-feature-card__title--${color}`}>
        {title}
      </div>
      <div className="home-feature-card__desc">{description}</div>
    </div>
    <div className={`home-feature-card__arrow home-feature-card__arrow--${color}`}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="m9 6 6 6-6 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  </div>
);

export default FeatureCard;
